var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAvatar1 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1904",
    "data-name": "Group 1904",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_360",
    "data-name": "Ellipse 360",
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#fff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_361",
    "data-name": "Ellipse 361",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(0)",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_64",
    "data-name": "Mask Group 64",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550",
    transform: "translate(1.072 7.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24414",
    "data-name": "Path 24414",
    d: "M2388.158,4700.9s-12.1,5.277-18.374,11.442a27.732,27.732,0,0,0-7.636,12.817l68.664.665s-4.273-10.944-12.134-17.6-18.474-8.647-18.474-8.647a31.332,31.332,0,0,1-7.223,2.336C2389.681,4702.4,2388.158,4700.9,2388.158,4700.9Z",
    transform: "translate(-2362.148 -4662.669)",
    fill: "#fee4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24409",
    "data-name": "Path 24409",
    d: "M2397.872,4692.313s12.78-2.149,11.751-8.821a22.522,22.522,0,0,0-5.63-10.885c-4.257-4.38-10.212-6.346-10.236-6.988s2.369-1.062,2.657-3.865a3.364,3.364,0,0,0-2.942-3.685,3.53,3.53,0,0,0-3.935,2.454c-.8,2.521,1.232,4.063,1.075,4.74s-6.47-.027-10.013,5.134a26.282,26.282,0,0,0-4.112,11.033s-1.086,6.683,1.031,9.759,4.446,2.242,9.346,2.794S2397.872,4692.313,2397.872,4692.313Z",
    transform: "translate(-2361.218 -4658.032)",
    fill: "#20110c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24406",
    "data-name": "Path 24406",
    d: "M2401.155,4697.719a7.074,7.074,0,0,1-3.074-4.04,39.346,39.346,0,0,1-1.5-8.49,32.365,32.365,0,0,1-3.663,4.826,7.645,7.645,0,0,1-3.306,2.072,17.951,17.951,0,0,1,.265,4.009,6.619,6.619,0,0,1-.9,2.819,8.787,8.787,0,0,0,5.48,1.47C2397.5,4700.087,2401.155,4697.719,2401.155,4697.719Z",
    transform: "translate(-2363.004 -4660.773)",
    fill: "#9b6537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24407",
    "data-name": "Path 24407",
    d: "M2394.091,4689.289a40.263,40.263,0,0,1-1.969,4.887,5.162,5.162,0,0,1-2.388,2.457,14.935,14.935,0,0,0,.2-2.187,16.722,16.722,0,0,0-.12-1.931,3.711,3.711,0,0,0,1.5-.659A17.584,17.584,0,0,0,2394.091,4689.289Z",
    transform: "translate(-2363.054 -4660.114)",
    fill: "#89532d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24408",
    "data-name": "Path 24408",
    d: "M2396,4683.468a23.665,23.665,0,0,1-4.129,5.7c-2.369,2.208-3.06,2.739-5.594,2.587s-3.745-2.562-4.633-4.656-1.565-7.677-.781-12.059,3.174-5.126,4.014-5.3a7.855,7.855,0,0,1,6.351,1.534c2.478,2.062,2.9,6.081,3.46,6.542s1.154-1.411,2.609-.67,1.251,4.1.533,5.022A4.455,4.455,0,0,1,2396,4683.468Z",
    transform: "translate(-2361.505 -4658.805)",
    fill: "#9b6537"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_356",
    "data-name": "Ellipse 356",
    transform: "translate(19.462 19.031)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.836,
    cy: 0.836,
    rx: 0.836,
    ry: 0.836,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.836,
    cy: 0.836,
    rx: 0.336,
    ry: 0.336,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_357",
    "data-name": "Ellipse 357",
    transform: "translate(25.995 19.031)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.836,
    cy: 0.836,
    rx: 0.836,
    ry: 0.836,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.836,
    cy: 0.836,
    rx: 0.336,
    ry: 0.336,
    fill: "none"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_358",
    "data-name": "Ellipse 358",
    cx: 1.307,
    cy: 1.307,
    rx: 1.307,
    ry: 1.307,
    transform: "translate(30.215 45.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_359",
    "data-name": "Ellipse 359",
    cx: 1.307,
    cy: 1.307,
    rx: 1.307,
    ry: 1.307,
    transform: "translate(30.215 51.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24412",
    "data-name": "Path 24412",
    d: "M5358.7,1879.478a16.5,16.5,0,0,0-1.34,3.071c.027.5,1.34.858,1.34.858Z",
    transform: "translate(-5335.689 -1858.344)",
    fill: "#89532d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24413",
    "data-name": "Path 24413",
    d: "M5357.665,1886.435l4.747-.1s-.761,2.805-2.583,2.713S5357.665,1886.435,5357.665,1886.435Z",
    transform: "translate(-5336.676 -1859.744)",
    fill: "#fff",
    stroke: "#89532d",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24415",
    "data-name": "Path 24415",
    d: "M2393.336,4702.457l-4.021,2.905-.456-3.957a9.632,9.632,0,0,0,2.158.819A16.031,16.031,0,0,0,2393.336,4702.457Z",
    transform: "translate(-2362.062 -4662.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24416",
    "data-name": "Path 24416",
    d: "M2399.776,4700.734l-1.993,4.583-3.112-2.933a21.645,21.645,0,0,0,2.654-.643A19.348,19.348,0,0,0,2399.776,4700.734Z",
    transform: "translate(-2363.383 -4662.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24417",
    "data-name": "Path 24417",
    d: "M.467-.018A4.1,4.1,0,0,1,1.8-.265a5.653,5.653,0,0,1,1.471.247.467.467,0,1,1,0,.933A6.724,6.724,0,0,0,1.8.712a4.854,4.854,0,0,0-1.329.2.467.467,0,0,1,0-.933Z",
    transform: "translate(25.062 16.788)",
    fill: "#20110c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24418",
    "data-name": "Path 24418",
    d: "M.467-.018A4.1,4.1,0,0,1,1.8-.265a5.653,5.653,0,0,1,1.471.247.467.467,0,1,1,0,.933A6.724,6.724,0,0,0,1.8.712a4.854,4.854,0,0,0-1.329.2.467.467,0,0,1,0-.933Z",
    transform: "translate(25.062 16.788)",
    fill: "#20110c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24419",
    "data-name": "Path 24419",
    d: "M.467-.018A4.1,4.1,0,0,1,1.8-.265a5.653,5.653,0,0,1,1.471.247.467.467,0,1,1,0,.933A6.724,6.724,0,0,0,1.8.712a4.854,4.854,0,0,0-1.329.2.467.467,0,0,1,0-.933Z",
    transform: "translate(18.528 16.788)",
    fill: "#20110c"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAvatar1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/avatar-1.59dda9eb.svg";
export { ForwardRef as ReactComponent };